import { render, staticRenderFns } from "./LgFinderPageRequisicoes.vue?vue&type=template&id=b352e80a"
import script from "./LgFinderPageRequisicoes.vue?vue&type=script&lang=js"
export * from "./LgFinderPageRequisicoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports